import { IconFont } from '@byecode/ui'
import { flexMinSizeCSS } from '@lighthouse/shared'
import styled from 'styled-components'

import { AnimationDecorators } from '../../components'
import { SCxButtonWrapper } from './ExportContent'

export const ChartViewBlockContainer = styled(AnimationDecorators)`
    ${flexMinSizeCSS}
    position: relative;
    height: calc(100% - 8px);
    margin: var(--block-padding);
    min-height: 32px;
    border-radius: 8px;
    border: none;
    font-size: var(--font-size-normal);
    display: flex;
    flex-direction: column;

    &:hover ${SCxButtonWrapper} {
        opacity: 1;
    }
`

export const ChildContainer = styled.div`
    display: flex;
    flex-flow: wrap row;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    gap: 8px;
`

export const ChildChartViewContainer = styled.div`
    overflow: hidden;
    width: 100%;
    height: 100%;
`

export const IndicatorChartViewContentWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    /* min-height: 164px; */
    height: 100%;
    padding: 16px;
    border: 1px solid var(--color-gray-200);
    border-radius: 12px;
    background: var(--color-white);
    overflow: hidden;

    transition: all 0.2s ease-in-out;

    &:hover {
        box-shadow: 0px 0px 6px 0px rgba(56, 56, 56, 0.12);
    }
`

export const ChartViewContentWrapper = styled.div<{ height?: number }>`
    width: 100%;
    height: ${({ height }) => (height ? `${height}px` : '100%')};
    padding: 16px;
    border: 1px solid var(--color-gray-200);
    border-radius: 12px;
    background: var(--color-white);

    transition: all 0.2s ease-in-out;
`
